export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '117a5176-3960-4485-9995-0f7f863d7d1d';
export const MODAL_CLOSE_SEC = 2.5;
